import { render, staticRenderFns } from "./ViewPlotDetails800.vue?vue&type=template&id=22610dbe"
import script from "./ViewPlotDetails800.vue?vue&type=script&lang=ts"
export * from "./ViewPlotDetails800.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports